import MainHeader from '@/components/MainHeader';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';
import { BreadcrumbSchema } from '@/components/SchemaOrg';

const CookiePolicy = () => {
  return (
    <>
      <SEOHead
        title="Cookie Policy | Materialidtf.it"
        description="Informativa sui cookie di Materialidtf.it. Scopri quali cookie utilizziamo e come gestirli."
        canonical="/cookie-policy"
        noindex={false}
      />
      <BreadcrumbSchema
        items={[
          { name: 'Home', url: '/' },
          { name: 'Cookie Policy', url: '/cookie-policy' }
        ]}
      />

      <MainHeader />
      <Navigation />

      <main className="min-h-screen bg-background py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold text-foreground mb-8">Cookie Policy</h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-sm text-muted-foreground">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. Cosa Sono i Cookie</h2>
              <p>
                I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. I cookie sono utilizzati per diverse finalità, hanno caratteristiche diverse e possono essere utilizzati sia dal titolare del sito che da terze parti.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Tipologie di Cookie Utilizzati</h2>
              
              <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">2.1 Cookie Tecnici (Necessari)</h3>
              <p>
                Sono cookie necessari per il corretto funzionamento del sito. Includono cookie di sessione, di navigazione e funzionali. Non richiedono il consenso dell'utente.
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Cookie di sessione per mantenere lo stato di login</li>
                <li>Cookie del carrello per memorizzare i prodotti</li>
                <li>Cookie di preferenze linguistiche</li>
              </ul>

              <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">2.2 Cookie Analitici</h3>
              <p>
                Sono cookie utilizzati per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito. Utilizziamo questi dati per migliorare il sito e l'esperienza utente.
              </p>

              <h3 className="text-xl font-semibold text-foreground mt-6 mb-3">2.3 Cookie di Profilazione</h3>
              <p>
                Sono cookie utilizzati per tracciare la navigazione dell'utente in rete e creare profili sui suoi gusti, abitudini, scelte, ecc. Con questi cookie possono essere trasmessi al terminale dell'utente messaggi pubblicitari in linea con le preferenze già manifestate dallo stesso utente nella navigazione online.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. Cookie di Terze Parti</h2>
              <p>Il nostro sito può utilizzare cookie di terze parti per le seguenti finalità:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Google Analytics:</strong> per l'analisi statistica delle visite</li>
                <li><strong>Facebook Pixel:</strong> per il remarketing pubblicitario</li>
                <li><strong>Google Ads:</strong> per la pubblicità personalizzata</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Gestione dei Cookie</h2>
              <p>
                L'utente può gestire le preferenze relative ai cookie direttamente all'interno del proprio browser ed impedire che terze parti possano installarli.
              </p>
              <p className="mt-4">
                Di seguito i link alle istruzioni per la gestione dei cookie nei browser più diffusi:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Safari</a></li>
                <li><a href="https://support.microsoft.com/it-it/windows/eliminare-e-gestire-i-cookie-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Microsoft Edge</a></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Durata dei Cookie</h2>
              <p>I cookie hanno una durata diversa a seconda della loro tipologia:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li><strong>Cookie di sessione:</strong> scadono alla chiusura del browser</li>
                <li><strong>Cookie persistenti:</strong> rimangono memorizzati fino alla loro scadenza o cancellazione da parte dell'utente</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">6. Aggiornamenti</h2>
              <p>
                La presente Cookie Policy può essere soggetta a modifiche. Si consiglia di consultare periodicamente questa pagina per essere sempre aggiornati.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">7. Contatti</h2>
              <p>
                Per qualsiasi domanda relativa alla presente Cookie Policy, è possibile contattarci a:
              </p>
              <ul className="list-none mt-4 space-y-2">
                <li><strong>Email:</strong> privacy@materialidtf.it</li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default CookiePolicy;
